import {HttpClient} from '@angular/common/http'
import {inject, Injectable, signal} from '@angular/core'
import {IKycPersonDataset} from '@sparbanken-syd/borgo-types'
import {Observable, tap} from 'rxjs'

import {environment} from '../../environments/environment'
import {Kyc} from '../application/kyc'

export type PutKycResponse = { errorMessage?: string } | boolean

@Injectable({
  providedIn: 'root'
})
export class KycService {

  public loaded = signal(false)

  public found = signal(false)

  public kycModel = new Kyc({})

  protected http = inject(HttpClient)

  public getKyc(): Observable<IKycPersonDataset> {
    this.loaded.set(false)
    this.found.set(false)
    this.kycModel = new Kyc({}) // Reset Kyc before getting user
    const url = `${environment.kycApiUrl}/user`
    return this.http.get<IKycPersonDataset>(url).pipe(
      tap((kyc: IKycPersonDataset) => {
        this.kycModel = new Kyc(kyc)
        // Use name as indication of actual kyc.
        this.found.set(!!kyc.personBasicDataset?.personNameDataset)
        this.loaded.set(true)
      })
    )
  }

  public putKyc(): Observable<PutKycResponse> {
    const url = `${environment.kycApiUrl}/user`
    return this.http.put<PutKycResponse>(url, this.kycModel.kyc)
  }
}